import React from 'react'
import GoogleMapWrapperForDetailView from './GoogleMapWrapperForDetailView'
import { firstMapPinDeViceIcon } from '../../icons'

type Props = {
  detectionLogs: Pick<IDetectionLog, 'detected_at' | 'latitude' | 'longitude'>[]
  blueprints: IBlueprint[]
}

const DetailDeviceViewMap = ({
  detectionLogs,
  blueprints,
}: Props) => (
  <div className="map-view">
    <div className="map">
      <GoogleMapWrapperForDetailView
        containerStyle={{ height: '445px' }}
        zoom={18}
        detectionLogs={detectionLogs}
        mapPinIconSrc={firstMapPinDeViceIcon}
        blueprints={blueprints}
      />
    </div>
  </div>
)

export default DetailDeviceViewMap
